module.exports = __webpack_public_path__ + "img/scene.0c061596.svg";